import React, { useRef, useEffect, useState } from 'react';
import { View } from 'react-native';
import { useToast } from 'react-native-toast-notifications';
import { Page, DataGrid, BText, DataGridColumn, showToast, Drawer, PageTitle } from '../../../../components';
import { Button, Input, InputRefProps, ButtonContainer } from '../../../../components/Form';
import { UserInputSchema } from '../../../../types';
import stateJson from '../../../../assets/data/state.json';
import cityJson from '../../../../assets/data/city.json';

export const AdminAdminAddressCity = () => {
  type CityObject = {
    id: number;
    name: string;
    status: boolean;
    state: string;
  };

  // type StateObject = {
  //   name: string;
  //   code: string;
  //   status: boolean;
  // };

  // const [cityData, setCityData] = useState<CityObject[]>([
  //   { id: 1, name: 'Puchong', status: true, state: 'Selangor' },
  //   { id: 2, name: 'Ampang', status: true, state: 'Selangor' },
  //   { id: 3, name: 'Ipoh', status: true, state: 'Perak' },
  // ]);

  // const [stateData, setStateData] = useState<StateObject[]>([
  //   { name: 'Selangor', code: 'SGR', status: true },
  //   { name: 'Perak', code: 'PRK', status: true },
  //   { name: 'WP Kuala Lumpur', code: 'KUL', status: true }
  // ]);

  const toast = useToast();
  const inputCityName = useRef<InputRefProps>(null);
  const inputStateName = useRef<InputRefProps>(null);
  const [isAddView, setIsAddView] = useState<boolean>(false);
  const [isEditView, setIsEditView] = useState<boolean>(false);
  const [cityName, setCityName] = useState<string>('');
  const [selectedState, setSelectedState] = useState<string>('');
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedCity, setSelectedCity] = useState<any>(null);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [states, setStates] = useState(stateJson);
  const [cities, setCities] = useState(cityJson);

  const column: DataGridColumn[] = [
    { label: 'City', key: 'name', width: 100, sortable: true },
    { label: 'State', key: 'state', width: 100, sortable: true },
    {
      label: 'Status',
      key: 'status',
      width: 100,
      sortable: true,
      dataType: 'boolean',
      cellRender: (item: any) => <BText>{` ${item.status ? 'Active' : 'Inactive'}`}</BText>,
    },
  ];

  useEffect(() => {
    setStates(
      stateJson
        .map((row: any) => {
          row.value = row.name;
          row.label = row.name;
          row.sort = row.id;
          return row;
        })
        // .sort((a: any, b: any) => a.label.localeCompare(b.label)),
        .sort((a, b) => a.id - b.id),
    );
  }, []);

  useEffect(() => {
    setSelectedState(selectedState);
    setSelectedId(selectedId);
  }, []);

  useEffect(() => {
    updateInputValue(inputStateName.current, '');
    updateInputValue(inputCityName.current, '');
  }, []);

  const incrementId = () => {
    return isEditView ? selectedId : cities[cities.length - 1].id + 1;
  };

  const doSaveBtn = () => {
    const newCity: CityObject = {
      id: incrementId(),
      name: inputCityName.current?.value || '',
      status: true,
      state: selectedState,
    };
    handleAddOrUpdate(newCity);
    setIsAddView(false);
    clearInputValue();
  };

  const doCancelBtn = () => {
    setIsAddView(false);
    setIsEditView(false);
    clearInputValue();
  };

  const updateInputValue = (element: InputRefProps | null, value: string) => {
    if (element) element.setValue(value);
  };

  const handleAddOrUpdate = (newCity: CityObject) => {
    const existingCityIndex = cities.findIndex(city => city.id === newCity.id);

    if (existingCityIndex !== -1) {
      const updatedCityData = [...cities];
      updatedCityData[existingCityIndex] = newCity;
      setCities(updatedCityData);
    } else {
      setCities(prevData => [...prevData, newCity]);
    }
  };

  const showEditItemView = (editSelectedCity: any) => {
    setIsAddView(true);
    setIsEditView(true);
    populateSelectedEditItem(editSelectedCity);
  };

  const populateSelectedEditItem = (populateSelectedCity: any) => {
    setCityName(populateSelectedCity.name);
    setSelectedState(populateSelectedCity.state);
    setSelectedId(populateSelectedCity.id);
  };

  const showDeleteDrawer = (selectedItemIndex: any) => {
    setSelectedCity(selectedItemIndex);
    setShowDelete(true);
  };

  const handleDeleteItem = () => {
    const updatedCityData = cities.filter(city => city.name !== selectedCity.name);
    setCities(updatedCityData);
  };

  const handleActivationItem = (selectedItemIndex: any) => {
    const itemsToSelect = cities.map(item => {
      if (selectedItemIndex.id === item.id) {
        return {
          ...item,
          status: !item.status,
        };
      }
      return item;
    }, []);

    setCities(itemsToSelect);
    showToast(toast, {
      message: selectedItemIndex.status
        ? `${selectedItemIndex.name} is disabled`
        : `${selectedItemIndex.name} is enabled`,
    });
  };

  const clearInputValue = () => {
    if (isEditView) {
      setCityName('');
      setSelectedState('');
      setSelectedId(0);
    }
  };

  return (
    <Page title={'City Setup'}>
      {!isAddView && (
        <View>
          <DataGrid
            data={cities}
            columns={column}
            actions={[
              {
                label: 'Active',
                action: (item: any) => handleActivationItem(item),
                disable: (item: any) => item.status,
              },
              {
                label: 'Deactivate',
                action: (item: any) => handleActivationItem(item),
                disable: (item: any) => !item.status,
              },
              {
                label: 'Edit',
                action: (item: any) => showEditItemView(item),
              },
              {
                label: 'Delete',
                action: (item: any) => showDeleteDrawer(item),
                disable: (item: any) => !item.status,
              },
            ]}
            defaultSort={{ key: 'city', direction: 'ascending' }}
            onDoubleClick={(item: any) => console.log('DblClick', item)}
            onSelect={(item: any) => console.log('select', item)}
            primaryButton={{
              label: 'Add City',
              action: () => setIsAddView(true),
            }}
          />
        </View>
      )}

      {isAddView && (
        <View>
          {!isEditView ? <PageTitle>Add New City</PageTitle> : <PageTitle>Edit City</PageTitle>}
          <Input
            label={'State'}
            id="state"
            type="select"
            dataSource={states}
            value={!isEditView ? '' : selectedState}
            onChange={(v: string) => setSelectedState(v)}
            schemaContext={{ isEdit: true }}
            ref={inputStateName}
          />

          <Input
            label={'City Name'}
            id="city"
            value={!isEditView ? '' : cityName}
            schemaObject={UserInputSchema}
            schemaContext={{ isEdit: true }}
            ref={inputCityName}
          />

          <ButtonContainer direction="horizontal">
            <Button onPress={() => doSaveBtn()}>Save</Button>
            <Button onPress={() => doCancelBtn()}>Cancel</Button>
          </ButtonContainer>
        </View>
      )}

      <Drawer
        id="city.delete"
        visible={showDelete}
        type={'onCancel'}
        onClose={() => setShowDelete(false)}
        onOK={handleDeleteItem}
        title={'Confirmation'}
      >
        <BText>Are you confirm to delete the city?</BText>
      </Drawer>
    </Page>
  );
};
